import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from '~/base/BaseServices.module.scss';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

// const DigitalTransformation = ({ t }) => {
const Outsourcing = () => {
    const { t } = useTranslation();
    let { pathname } = useLocation();

    const data = {
        title: t('Exciting IT Outsourcing'),
        indexClass: 2,
        titleTech: t('Outsourced IT services enable you'),
        video: 'https://video.wixstatic.com/video/c794a2_335ed2899af5425c953ae39da5819c22/720p/mp4/file.mp4',
        titleContent: t('Outsourcing'),
        poster: 'https://static.wixstatic.com/media/c794a2_335ed2899af5425c953ae39da5819c22f000.jpg/v1/fill/w_761,h_532,al_c,q_85,usm_0.33_1.00_0.00,enc_auto/c794a2_335ed2899af5425c953ae39da5819c22f000.jpg',
        content: t('Outsourced IT services'),
    };
    const detailServices = [
        {
            label: t('Application Development'),
            description: t('(Custom software, mobile/web apps, legacy system upgrades)'),
            image: require('../../assets/images/services/outsourcing/application-development-maintenance.png'),
        },
        {
            label: t('Infrastructure Outsourcing'),
            description: t('(Cloud services, data center management, network support)'),
            image: require('../../assets/images/services/outsourcing/infrastructure-outsourcing.png'),
        },
        {
            label: t('Help Desk & Technical Support'),
            description: t('(24/7 user support, troubleshooting)'),
            image: require('../../assets/images/services/outsourcing/help-desk-technical-support.png'),
        },
        {
            label: t('Cybersecurity & Compliance'),
            description: t('(Risk assessment, threat monitoring, GDPR/HIPAA compliance)'),
            image: require('../../assets/images/services/outsourcing/cybersecurity-compliance-2.png'),
        },
        {
            label: t('Managed IT Services'),
            description: t('(End-to-end IT operations handled by a third party)'),
            image: require('../../assets/images/services/outsourcing/managed-it-services.png'),
        },
        {
            label: t('Business Process Outsourcing'),
            description: t('(IT-enabled services like data entry, customer support)'),
            image: require('../../assets/images/services/outsourcing/bpo.png'),
        },
    ]
    const ctaData = {
        title: t('Hand off your complex IT tasks to a trusted partner'),
        description: t('Digital transformation applications maximize operational processes with unimaginable benefits'),
    }

    return (
        <div className={cx('solution')}>
            <div className={cx('solution__intro')}>
                <div
                    className={cx('solution__intro-wraper')}
                    style={{
                        position: 'absolute',
                        maxWidth: '900px',
                        left: '110px',
                        top: '26px',
                    }}
                >
                    <div className={cx('solution__intro__title')}>{data.title}</div>
                    <div className={cx('solution__intro__description')}>{data.titleTech}</div>
                </div>
            </div>

            <div className={cx('solution__new', 'solution__new-service-' + data.indexClass)}>
                <div className={cx('solution__new__top')}>
                    <div className={cx('solution__new__top__content')}>{data.titleContent}</div>
                    <div className={cx('solution__new__top__content-two')}>
                        <p>{data.content}</p>
                    </div>
                </div>
                <div>
                    {window.innerWidth > 768 ? (
                        <video
                            crossOrigin="anonymous"
                            playSinline="true"
                            preload="auto"
                            loop
                            tabIndex="-1"
                            autoPlay
                            muted
                            src={data.video}
                            className="desktop-video"
                            style={{ width: '800px', maxWidth: '100%' }}
                        ></video>
                    ) : (
                        <img style={{ width: '100%' }} src={data.poster} alt="Mobile Image" />
                    )}
                </div>
            </div>
            {/* Services Grid Section */}
            <div className={cx("solution__services", "solution__services__" + pathname.split('/')[1])}>
                <div className={cx("solution__services__title")}>
                    {t("Focus your expertise while taking full advantage of the latest technologies")}
                </div>

                <div className={cx("solution__services__description")}>
                    {t("Our IT Outsourcing services give you access to enterprise-level technology and expertise, adapted to your organization's needs.")}
                </div>

                <div className={cx("solution__services__grid")}>
                    {detailServices.map((service, index) => (
                        <div className={cx("solution__services__item")}>
                            <div className={cx("solution__services__item__image")}>
                                <img src={service.image} alt={service.label} />
                            </div>
                            <div className={cx("solution__services__item__content")}>
                                <div className={cx("solution__services__item__content__text")}>
                                    <h3>{service.label}</h3>
                                    <p>{service.description}</p>
                                </div>
                                <div className={cx("solution__services__item__content__arrow")}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Call to Action Section */}
            <div className={cx("solution__cta")}>
                <div className={cx("solution__cta__content", "solution__cta__content__" + pathname.split('/')[1])}>
                    <div className={cx("solution__cta__text")}>
                        <h2>{ctaData.title}</h2>
                        <p>{ctaData.description}</p>
                        <Link to="/contact" className={cx("solution__cta__button")}>
                            {t("CONTACT US >")}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Outsourcing
